let dateSelector = document.querySelector(".main-footer__year");
if (dateSelector !== null) {
  dateSelector.textContent = new Date().getFullYear();
}